/* eslint-disable react/require-default-props */
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Layout } from '@vwfs-bronson/bronson-react';
import { useFormikContext } from 'formik';
import { store } from '../../../services/redux';
import { quoteSelectors } from '../../../services/redux/features/quote.slice';
import { useNavigate } from '../../../services/routing/navigate';
import { AnyCustomerProspectForm } from './initialValues';

interface Props {
  isCoCustomer?: boolean;
  isCompanyClosed?: boolean;
}

export const ProspectPageButtons: FunctionComponent<Props> = ({ isCoCustomer, isCompanyClosed }) => {
  const { t } = useTranslation();
  const { submitForm } = useFormikContext<AnyCustomerProspectForm>();
  const navigate = useNavigate();
  const state = store.getState();
  const isFormDisabled = !quoteSelectors.selectIsQuoteEditable(state);

  return (
    <Layout.Item>
      <Layout center>
        <Layout.Item default="1/3">
          <Button
            type="button"
            full
            secondary
            onClick={() => {
              if (isCoCustomer) {
                navigate.form(2);
              } else if (isFormDisabled) {
                navigate.form(1);
              } else {
                navigate.selectCustomerType();
              }
            }}
          >
            {t('step2:navigation:return')}
          </Button>
        </Layout.Item>
        <Layout.Item default="1/3">
          <Button full type="submit" onClick={submitForm} disabled={isCompanyClosed}>
            {t('step2:navigation:next')}
          </Button>
        </Layout.Item>
      </Layout>
    </Layout.Item>
  );
};
